/**
 * sl-728o.3.1: Output Mapping Session
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';

type I18n = ReturnType<typeof useI18n>;

export function createOutputMappingSession(t: I18n): TutorialSession {
  return {
    id: 'automation:outputMapping',
    context: {
      targetAudience: 'technical',
      category: 'automation',
      tab: 'output',
    },
    steps: [
      {
        targetSelector: '[data-section="field-mapping"]',
        title: t['com.streamlain.streamlain.coach.mapping-intro.title'](),
        content: t['com.streamlain.streamlain.coach.mapping-intro.content'](),
        animation: 'pulse',
      },
      {
        targetSelector: '[data-section="field-mapping"]',
        title: t['com.streamlain.streamlain.coach.mapping-keys.title'](),
        content: t['com.streamlain.streamlain.coach.mapping-keys.content'](),
        animation: 'highlight',
      },
      {
        targetSelector: '[data-section="field-mapping"]',
        title: t['com.streamlain.streamlain.coach.mapping-relations.title'](),
        content:
          t['com.streamlain.streamlain.coach.mapping-relations.content'](),
        animation: 'pulse',
      },
      {
        targetSelector: '[data-section="field-mapping"]',
        title: t['com.streamlain.streamlain.coach.mapping-fixed.title'](),
        content: t['com.streamlain.streamlain.coach.mapping-fixed.content'](),
        animation: 'highlight',
      },
    ],
  };
}
